/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a new tag.
 * @export
 * @interface TagCreate
 */
export interface TagCreate {
    /**
     * 
     * @type {string}
     * @memberof TagCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TagCreate
     */
    description?: string | null;
}

/**
 * Check if a given object implements the TagCreate interface.
 */
export function instanceOfTagCreate(value: object): value is TagCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TagCreateFromJSON(json: any): TagCreate {
    return TagCreateFromJSONTyped(json, false);
}

export function TagCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function TagCreateToJSON(json: any): TagCreate {
    return TagCreateToJSONTyped(json, false);
}

export function TagCreateToJSONTyped(value?: TagCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

